<template>
    <div class="text-center" v-bind:class="css">
        <div class="w-1/4 h-1 inline-block bg-primary-red"></div>
        <div class="w-1/4 h-1 inline-block bg-primary-orange"></div>
        <div class="w-1/4 h-1 inline-block bg-primary-blue"></div>
        <div class="w-1/4 h-1 inline-block bg-primary-green"></div>
    </div>
</template>

<script>
    export default {
        name: "seperator",
        props: {
            css: String
        }
    }
</script>